import React, { useEffect, useState, useCallback } from 'react'
import './OduLandingPage.scss'
import PlanTable from '../PlanTable/PlanTable';
import DynamicForm from '../DynamicForm';
import { geoCode, getFormSchema, getCityData } from '../service';
import { getBundles, getLineType, getOtpV1, submitLead } from '../../../orp/shared/service';
import { useLoading } from '../../../../Shared/cache/context/LoadingProvider';
import AwOtpModal from '../AwOtpModal';
import Modal from '../../../../Shared/Components/Modal';
import { useNavigate } from 'react-router-dom';
import MapPicker from '../MapPicker';
import ToastMsg from '../../../orp/shared/components/ToastMsg/ToastMsg';
import { eventEmitter } from '../../../../Shared/service/google-analytics.service';
import { AW_TRANSANCTION_TYPE, FORM_SCHEMA, SERVICE_TYPE } from '../../constant/constant';
import useFetch from "../../../../Shared/cache/useFetch";
import { useLanguage } from "../../../../Shared/cache/context/LanguageProvider";
import { TRANSLATION, GET, ORP_TRANSLATION } from "../../../../Shared/helper/constants";

const OduLandingPage = ({ deviceDetails }) => {

  const [bundleData, setBundleData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [isServiceable, setIsServiceable] = useState(false);
  const [hideServiceModal, setHideServiceModal] = useState(false);
  const [coordinates, setCoordinates] = useState({});
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isAirtelNumber, setIsAirtelNumber] = useState(false);
  const [refId, setRefId] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const [formSchema, setFormSchema] = useState({});
  const [showMap, setShowMap] = useState(false);
  const [bundles, setBundles] = useState([]);
  const [towns, setTowns] = useState([]);
  const [clearFormData, setClearFormData] = useState(false)
  const [isOtpLimitExhausted, setisOtpLimitExhausted] = useState(false);
  const [redirectUrl, setRedirectUrl]=useState('');

  const { showLoader, hideLoader } = useLoading();
  const navigate = useNavigate();
  const [translation, setTranslation] = useState({
    selectPlanText: "Select a 5G plan to continue",
    noteText: "The Pricing above includes taxes and one time connection fee of N20,000.",
    note: "Note-",
    customerDetails: "Customer Details",
    back:"Back",
    proceed:"Proceed",
    congratulations:"Congratulations!",
    serviceAvailableText:"Service is available in your area!",
    redirectMsg:"Redirecting you to the payment page shortly.",
    thankYou:"Thank you!",
    serviceUnavailableText:" For your interest in our 5G Outdoor Unit SmartConnect service. While the service is not yet available in your location,we have high-speed 4G routers and other reliable connectivity devices that might suit your needs. Redirecting you to the home page shortly.",
    exploreProduct:"Explore other Products"
    
});
  const { languagePrefix,selectedLanguage } = useLanguage();
  const { data: data,refetch } = useFetch({
        url: ORP_TRANSLATION.replace('languagePrefix', languagePrefix),
        method: GET,
        key: TRANSLATION,
        cache: {
            enabled: true,
            ttl: 3600
        }
    });
    useEffect(() => {
      if (data?.awlanding) setTranslation(data?.awlanding)
  }, [data])

  useEffect(() => {
      const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
      if (!cachedData) {
          refetch(true);
      }else {
      refetch(false)
      }
  }, [selectedLanguage]);
  useEffect(() => {
    fetchFormSchema()
    fetchBundles();
    let redirectUrl=sessionStorage.getItem('redirect_url');
    setRedirectUrl(redirectUrl);
  }, [])


  useEffect(() => {
    fetchFormSchema()
}, [selectedLanguage]);

  const fetchBundles = () => {
    let postRequest = {
      data: { "serviceType":SERVICE_TYPE },
    };
    showLoader();
    getBundles(postRequest).then(res => {
      if (res?.data?.statusCode == 200) {
        setBundles(res?.data?.result);
        eventEmitter('Airtel Works','Fetch Bundle Success','click','Fetch Bundle Success',null);
      }
      else{
        showToastMsg(
          "Error",
          res?.error?.message || res?.message || "Something Went Wrong!"
        );
        eventEmitter('Airtel Works','Fetch Bundle Failed','click',res?.error?.message || res?.message,null);
      }
      hideLoader();
    })
    .catch((error) => {
      hideLoader();
      showToastMsg(
        "Error",
        error?.error?.message || error?.message || "Something Went Wrong!"
      );
      eventEmitter('Airtel Works','Fetch Bundle Failed','click',error?.error?.message || error?.message,null);
    });
  }

  const fetchFormSchema = () => {
    let url=FORM_SCHEMA.replace('languagePrefix', languagePrefix)
    getFormSchema(url).then(resp => {
      setFormSchema(JSON.parse(resp?.data?.packageHtml));
      fetchTownList(JSON.parse(resp?.data?.packageHtml));
      eventEmitter('Airtel Works','Fetch Form Fields Success','click','',null);
    })
  }

  const fetchTownList = (data) => {
    getCityData().then(res => {
      let towns = res?.data?.result?.data ||[];
      setTowns(towns)
      let schema = { ...data };
      schema = {
        ...schema,
        fields: schema?.fields?.map((field) =>
          field.type === 'select' && field.name === 'town'
            ? { ...field, options: towns?.map((town) => ({ value: town?.cityName, label: town?.cityName })) }
            : field
        ),
      };

      setFormSchema(schema);
      eventEmitter('Airtel Works','Fetch Town List Success','click','Fetch Town List Success',null);
    });
  };

  const fetchCoordinates = async (address, landmark, town) => {
    const addressCoords = await geoCode(`${address} + ${town}`);
    let coords = addressCoords?.data?.results?.[0]?.geometry?.location
    if (coords && coords?.lat && coords?.lng) {
      return coords
    }
    const landmarkCoords = await geoCode(`${landmark?landmark:""} + ${town}`);
    coords = landmarkCoords?.data?.results?.[0]?.geometry?.location
    if (coords && coords?.lat && coords?.lng) {
      return coords
    }
    const townCoords = await geoCode(town);
    coords = townCoords?.data?.results?.[0]?.geometry?.location
    if (coords && coords?.lat && coords?.lng) {
      return coords
    }
    // if(!Object.entries(coordinates || {})){
    //   return coordinates
    // }
    setShowMap(true);
  };


  const handleSubmit = async (formData) => {
    let coords = await fetchCoordinates(formData?.installationAddress, formData?.landmark, formData?.town);
    setFormData(formData)
    if (coords) {
      setCoordinates(coords);
    }
    if(coords)validateMsisdn(formData.msisdn,formData.email,formData.name)
  }

  const validateMsisdn = (msisdn = formData.msisdn, email = formData.email,name=formData.name) => {
    if(!email ){
      return
    }
    let requestData = {
      msisdn:
        process.env.REACT_APP_OPCO.toLowerCase() == "ga"
          ? "0" + msisdn
          : msisdn,
    };
    showLoader();
    getLineType(requestData)
      .then((res) => {
        res = res?.data;
        hideLoader();
        if (
          res?.status?.toLowerCase() == "success" ||
          res?.status?.toLowerCase() == 200
        ) {
          setIsAirtelNumber(true);
          sendOtp(msisdn, email,true,name);
          eventEmitter('Airtel Works','Validate Msisdn Success','click','Validate Msisdn Success',null);

        } else {
          setIsAirtelNumber(false);
          sendOtp(msisdn, email,false,name);
          eventEmitter('Airtel Works','Validate Msisdn Failed','click',res?.message,null);
        }
      })
      .catch((error) => {
        hideLoader();
        setIsAirtelNumber(false);
        sendOtp(msisdn, email,false,name);
        eventEmitter('Airtel Works','Validate Msisdn Failed','click',error?.error?.message,null);
      });
  };


  const showToastMsg = (type, message) => {
    setToastMsg({ type, message });
    setTimeout(() => setToastMsg(null), 10000);
  };

  const sendOtp = (msisdn = "", email,isAirtelNumber=false,name=formData.name) => {
    let postRequestData = {
      email,
      customerDetails:{
        fullName:name
      },
      requestType:AW_TRANSANCTION_TYPE
    };
    postRequestData ={...postRequestData,...(!isAirtelNumber?{}:{msisdn})};
    let postRequest = {
      data: postRequestData,
    };
    showLoader();
    getOtpV1(postRequest).then(
      (res) => {
        res = res?.data;
        hideLoader();
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          setShowOtpModal(true);
          setRefId(res?.result?.refId);
          checkServicability(formData?.town);
          eventEmitter('Airtel Works','Send Otp Success','click','Send Otp Success',null);
        } else {
          if (res &&
            (res?.status == 502 || res?.statusCode == 502)) {
            handleLimitExhaust();
          }
          showToastMsg("Error", res?.message || "Something Went Wrong!");
          eventEmitter('Airtel Works','Send Otp Failed','click',res?.message,null);
        }
      },
      (error) => {
        hideLoader();
        showToastMsg(
          "Error",
          error?.error?.message || error?.message || "Something Went Wrong!"
        );
        eventEmitter('Airtel Works','Send Otp Failed','click',error?.error?.message,null);
      }
    );
  };


  const toggleModalEvent = () => {
    setShowOtpModal(false);
  };

  const checkServicability = useCallback((selectedTown) => {
    let hbbLeadFeasibility = towns.find(
      (town) =>
        town?.cityName?.toLowerCase() === selectedTown?.toLowerCase() &&
        town.hbbLeadFeasibility
    );
    return !!hbbLeadFeasibility;
  }, [towns]);


  const handleSelectedPlan = (bundle) => {
    setBundleData(bundle);
  };

  const handleOtpVerified = (uniqueCode) => {
    setShowOtpModal(false);
    setIsOtpVerified(true);
    let leadId;
    let isFeasible = checkServicability(formData.town)
    if (isFeasible) {
      sessionStorage.setItem("queryData", JSON.stringify({
        ...bundleData, msisdn: formData?.msisdn,
        rechargeType: 'ODU PURCHASE', 
        lineType: isAirtelNumber ? bundleData?.lineType : 'INVALID',
        emailId: formData?.email,
        redirectPage: redirectUrl
      }), true);
      setIsServiceable(true);

    } else {
      setIsServiceable(false);
    }
    let postData = {
      fullName: formData?.name,
      contactNumber: formData?.msisdn,
      email: formData?.email,
      feasibility: isFeasible,
      address: {
        type: "INSTALLATION",
        landmark: formData.installationAddress,
        lat: coordinates?.lat,
        lng: coordinates?.lng,
        city: formData?.town,
        street1: formData.installationAddress,
        country: process.env.REACT_APP_COUNTRY
      },
      plan: {
        "code": bundleData?.productCode,
        "amount": bundleData?.amount,
        "currency": bundleData?.currency,
        "description": bundleData?.description
      },
      "source": "WEBPORTAL",
      "uniqueCode": uniqueCode,
       lineType:"Prepaid",
       consent:formData?.termsAndCondition
    }

    submitLead(postData).then(res => {
      leadId = res?.data?.result?.refLeadId;
      if (isFeasible && leadId) {
        sessionStorage.setItem('airtelWorks', JSON.stringify({ isAirtelWorks: true, id: leadId }))
        setTimeout(() => {
          setHideServiceModal(true);
          navigate('/payment/start');
        }, 3000)
        eventEmitter('Airtel Works','Lead submitted successfully','click','Lead submitted successfully',null);
      } else {
        if(isFeasible){
          showToastMsg("Error", "Something Went Wrong!")
          setHideServiceModal(true);
        }else{
          setTimeout(() => {
            setHideServiceModal(true);
            goToDeviceList();
          }, 6000)
        }
        eventEmitter('Airtel Works','Lead submission failed','click',res?.message,null);
      }
    })

  }

  const handleLimitExhaust = () => {
    setisOtpLimitExhausted(true);
    setShowOtpModal(false);
    setCoordinates({})
  }


  const handleMapAddress = (value) => {
    let { lat, lng } = value;
    setCoordinates({ lat, lng });
    setShowMap(false);
    validateMsisdn()
  }

  const goToDeviceList = () => {
    navigate(redirectUrl);
  };

  return (
    <>
      <div className="odu-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="device-wrap">
                <div className="device-details">
                  <div className="device-img">
                    <img
                      src={deviceDetails?.heading_image}
                      alt={"deviceImg"}
                    ></img>
                  </div>
                  <h5>{deviceDetails?.deviceName}</h5>

                 <div className='scroll-item'>
                 <ul>
                    {!!deviceDetails?.features?.length &&
                      deviceDetails?.features?.map((element) => (
                        <li>{element}</li>
                      ))}
                  </ul>
                 </div>
                </div>

                {!!Object.entries(bundleData).length && (
                  <div class="selected-plan">
                    <div class="selected-label">Selected Plan</div>
                    <div class="selected-card">
                      <h5>{bundleData?.description}</h5>
                      <p>
                        <strong>
                          {bundleData?.currency} {bundleData?.amount}{" "}
                        </strong>{" "}
                        <strong>
                          /{bundleData?.validity}
                          {bundleData?.validityUnit}
                        </strong>
                      </p>
                      <ul>
                        <li>
                          {bundleData?.data}
                          {bundleData?.dataUnit}
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-sm-9">
              <div className="plan-details">
                {!showForm && (
                  <>
                    <h5>{translation.selectPlanText}</h5>
                    <PlanTable
                      bundles={bundles}
                      translation=""
                      sendSelectedPlan={handleSelectedPlan}
                    />
                   {!!bundles?.length && <p className="airtel-works-note"><strong className="red">{translation.note} </strong>{translation.noteText}</p>}
                  </>
                )}
                {showForm && (
                  <>
                    <h5>{translation.customerDetails}</h5>
                    <DynamicForm
                      formSchema={formSchema}
                      handleSubmit={handleSubmit}
                      clearFormData={clearFormData}
                      handleBack={goToDeviceList}
                    />
                  </>
                )}
                {!showForm && (
                  <div class="button-wrap">
                    <a href={redirectUrl} className="back-button">
                      <img
                        src="https://cdn-webportal.airtelstream.net/website/uganda/assets/images/icons/back-arrow.svg"
                        alt={""}
                      />
                      {translation.back}
                    </a>
                    <button
                      className="button proceed"
                      disabled={!Object.entries(bundleData).length}
                      onClick={() => {setShowForm(true);window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                      });}}
                    >
                      {" "}
                      {translation.proceed}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showOtpModal && (
        <>
          <AwOtpModal
            msisdn={formData.msisdn}
            email={formData.email}
            isAirtelNumber={isAirtelNumber}
            refId={refId}
            toggleModalEvent={toggleModalEvent}
            sendOtpVerifiedEvent={handleOtpVerified}
            maxLimitExaustEvent={handleLimitExhaust}
          />
        </>
      )}
      {isServiceable && !hideServiceModal && (
        <Modal isOpen={isOtpVerified}>
          <>
            <div className="success-modal">
              <img src="assets/icons/correct.svg" width='50px' alt="success" />
              <h3>{translation.congratulations}</h3>
              <p>{translation.serviceAvailableText}</p>
              <p style={{ fontSize: "14px" }}>{translation.redirectMsg}</p>
            </div>
          </>
        </Modal>
      )}
      {!isServiceable && !hideServiceModal && (
        <Modal isOpen={isOtpVerified}>
          <>
            <div className="thank-modal">
            <img src="assets/icons/correct.svg" width='50px' alt="success" />
              <h3>{translation.thankYou}</h3>
              <p>
               {translation.serviceUnavailableText}
              </p>
              <button className="button" onClick={goToDeviceList}>
                {translation.exploreProduct}
                <img src="assets/icons/right-arrow-white.svg" width='40px' alt="success" />
              </button>
            </div>
          </>
        </Modal>
      )}
      {showMap && coordinates?.lat && <MapPicker onContinue={handleMapAddress} coordinates={coordinates} />}
      {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>}
      {showMap &&
        <MapPicker onContinue={handleMapAddress} />
      }
    </>

  );
};

export default OduLandingPage;
